import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ExplorePage } from '@/features/metric-hub/explore/ExplorePage';

export const Route = createFileRoute('/_authed/metric-hub/explore/$boardId')({
  validateSearch: z.object({
    token: z.string().optional(),
    // Shareable/bookmarkable active filter state (compact JSON). Decoded
    // strictly + fail-closed in ExplorePage; a bad value just opens the board
    // with its persisted filters.
    f: z.string().optional(),
    // Kiosk deep link: `?present=1&cycle=30` enters present mode on load and
    // starts auto-cycling, so a board can be bookmarked onto a wall screen.
    // Coerced + clamped here, so a hand-edited value can never reach the page.
    present: z.coerce.boolean().optional(),
    cycle: z.coerce.number().int().min(0).max(600).optional(),
  }),
  component: ExploreBoardRoute,
});

function ExploreBoardRoute() {
  const { boardId } = Route.useParams();
  const { token, f, present, cycle } = Route.useSearch();
  return (
    <ExplorePage
      boardId={boardId}
      shareToken={token}
      initialFiltersParam={f}
      autoPresent={present}
      initialCycleSeconds={cycle}
    />
  );
}
